import { getStationCode } from "../../network/NetworkUtil";
import {
  getDispatchDate,
  getDynamicPlansForDiff,
  getPerformanceData,
  getPlanId,
  logOperationalMetric,
  isPlanActedUpon,
  getLatestDynamicPlanId,
} from "../utils/utils";
import {
  getAPIGatewayDataFromParent,
  getCoralServiceDataFromParent,
  getFeatureStatus,
  getOverviewData,
} from "../../handler/ParentDataHandler";
import axios from "axios";
import { PICK, STAGE } from "../utils/Constants";
import { flowIdentifierConstant } from "../../settings/settingsv2/SettingsConstant";
import { formatGetPlanDetails } from "../../settings/SettingsUtil";
import { getLMOpsCoralServiceRequest } from "../../settings/settingsv2/SettingsNetworkAPI";
import {
  FEATURES,
  metricProcessName,
  HTTP_SUCCESS_STATUS,
} from "../../util/Constants";
import { RESOLUTION } from "../utils/PPAConstants";
import { STRINGS } from "../../outboundAmzl/util/Constants";

const metricPlanIdentifier = "planIdentifier=" + flowIdentifierConstant;
/**
 * API call for fetching Actual FPH
 * @param filter
 * @param processName
 * @param dispatcher
 */
export function fetchActualFPH(filter, processName, dispatcher, baseUrl) {
  if (processName === PICK || processName === STAGE) {
    getFPHDataForPickAndStage(filter, processName, dispatcher, baseUrl);
  } else {
    const request = {
      stationCode: getStationCode(),
      filters: filter,
      processName: processName,
    };
    getFPHData(dispatcher, request);
  }
}

/**
 * API call for fetching Actual FPH
 * @param filter
 * @param processName
 * @param dispatcher
 */
export function fetchTargetData(filter, processName, dispatcher) {
  const request = {
    stationCode: getStationCode(),
    filters: filter.selectedCycles,
    processName: processName,
  };
  getTargetData(dispatcher, request);
}

/**
 * API call for fetching Target Induct Sort FPH
 * @param filter
 * @param processName
 * @param dispatcher
 */
export function fetchInductSortTargetData(filter, dispatcher) {
  const cycleIds =
    filter.selectedCycles.length === 0
      ? filter.allCycles.map((cycle) => cycle.cycleName)
      : filter.selectedCycles;
  let filterMap = {
    Cycle: cycleIds,
  };
  const request = {
    nodeId: getStationCode(),
    filterMap: filterMap,
    performanceMetricsList: ["TARGET_INDUCT_FPH", "TARGET_SORT_FPH"],
  };
  getInductSortTargetData(dispatcher, request);
}

export async function fetchIsShiftPlanEnabledFeatureFlag(dispatcher) {
  getFeatureStatus([FEATURES.IS_SHIFT_PLAN_ENABLED]).then((res) => {
    if (res.data && res.data.isShiftPlanEnabled) {
      getPlannedHeadcounts(dispatcher);
    }
  });
}

export async function getPlannedHeadcounts(dispatcher) {
  const stationInsights = await getSettingsInsights();
  const date = getDispatchDate(stationInsights);
  const nodeId = getStationCode();
  const getAllShiftPlansRequest = {
    resourcePath: `/shift-plans`,
    httpMethod: "GET",
    processName: "shiftPlanManagementService",
    requestParams: {
      nodeId: [nodeId],
      ofdDate: [date],
    },
  };
  let planId;
  const startTime = Date.now();
  await getAPIGatewayDataFromParent(getAllShiftPlansRequest).then((result) => {
    logOperationalMetric(
      startTime,
      metricProcessName,
      "getShiftPlanId",
      result.status === HTTP_SUCCESS_STATUS,
    );
    if (result.status === 200) {
      planId = getPlanId(result.data);
    }
  });

  if (planId) {
    const getShiftPlanRequest = {
      resourcePath: `/shift-plans/plan`,
      httpMethod: "GET",
      processName: "shiftPlanManagementService",
      requestParams: {
        planId: [planId],
      },
    };
    getAPIGatewayDataFromParent(getShiftPlanRequest).then((result) => {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getShiftPlan",
        result.status === HTTP_SUCCESS_STATUS,
      );
      if (result.status === 200) {
        let output = result.data;
        dispatcher({
          type: "RECEIVE_PLANNED_HEADCOUNT_DATA",
          data: output.output.shiftPlan,
        });
        dispatcher({
          type: "RECEIVE_PPH_DATA",
          data: output.input.resourceProductivityInput
            .resourceProductivityList[0].pph,
        });
      }
    });
  }
}
export function fetchPVAData(filter, dispatcher) {
  const cycleIds =
    filter.selectedCycles.length === 0
      ? filter.allCycles.map((cycle) => cycle.cycleName)
      : filter.selectedCycles;

  const request = {
    nodeId: getStationCode(),
    cycleIds: cycleIds,
    processPath: "induct",
  };
  getPVAData(dispatcher, request);
  getPVAInbound(dispatcher, request);

  const tphQueryParams =
    "nodeId=" + request.nodeId + "&cycleId=" + request.cycleIds;
  getPerformanceMetric(dispatcher, request, tphQueryParams);
  getProcessPathAggregateDataMetric(dispatcher, request, tphQueryParams);
  fetchIsShiftPlanEnabledFeatureFlag(dispatcher);
}

export function fetchPVADataOutbound(filter, dispatcher, baseUrl) {
  try {
    getPVADataOutbound(filter, dispatcher, baseUrl);

    // fetch sort info
    const cycleIds =
      filter.selectedCycles.length === 0
        ? filter.allCycles.map((cycle) => cycle.cycleName)
        : filter.selectedCycles;
    const request = {
      nodeId: getStationCode(),
      cycleIds: cycleIds,
      processPath: "induct",
    };
    const tphQueryParams =
      "nodeId=" +
      request.nodeId +
      "&cycleId=" +
      request.cycleIds +
      "&process=OUTBOUND";
    getPVAData(dispatcher, request);
    getPerformanceMetric(dispatcher, request, tphQueryParams);
  } catch (e) {}
}

async function getPVADataOutbound(filter, dispatcher, baseUrl) {
  const startTime = Date.now();
  try {
    const cycleId =
      filter.selectedCycles.length === 0
        ? "AllCycles"
        : filter.selectedCycles.toString();
    const api = axios.create({ baseURL: baseUrl });
    const response = await api.get(
      "/rsws/performance/pva?nodeId=" + getStationCode() + "&cycle=" + cycleId,
    );
    logOperationalMetric(
      startTime,
      metricProcessName,
      "getPVADataOutbound",
      true,
    );
    dispatcher({ type: "RECEIVE_OUTBOUND_PVA_DATA", data: response.data });
  } catch (error) {
    logOperationalMetric(
      startTime,
      metricProcessName,
      "getPVADataOutbound",
      false,
    );
  }
}

export function fetchComplianceMetrics(filter, processName, dispatcher) {
  const request = {
    nodeId: getStationCode(),
    filters: filter,
  };
  getComplianceMetrics(dispatcher, processName, request);
}

async function getTargetData(dispatcher, request) {
  const cycleId =
    request.filters.toString() !== ""
      ? request.filters.toString()
      : "AllCycles";
  const args = {
    processName: "flow/" + request.processName,
    queryParams: "stationCode=" + request.stationCode + "&cycleId=" + cycleId,
  };
  const startTime = Date.now();
  getOverviewData(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(startTime, metricProcessName, "getTargetData", true);
      if (result.data) {
        dispatcher({ type: "RECEIVE_TARGET_DATA", data: result.data });
      }
    } else {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getTargetData",
        false,
      );
    }
  });
}

async function getFPHDataForPickAndStage(
  filter,
  processName,
  dispatcher,
  baseUrl,
) {
  const startTime = Date.now();
  try {
    const cycleId = filter.toString() !== "" ? filter.toString() : "AllCycles";
    const metricList =
      processName === PICK ? ["ACTUAL_PICK_FPH"] : ["ACTUAL_STAGE_FPH"];
    const requestPayload = {
      stationCode: getStationCode(),
      metricList: metricList,
      cycle: cycleId,
    };
    const api = axios.create({ baseURL: baseUrl });
    const response = await api.post("/rsws/performance/flow", requestPayload);
    logOperationalMetric(
      startTime,
      metricProcessName,
      "getFPHDataForPickAndStage",
      true,
    );
    dispatcher({
      type: "RECEIVE_FPH_DATA",
      data: convertToFPHModel(response.data, processName),
    });
  } catch (error) {
    logOperationalMetric(
      startTime,
      metricProcessName,
      "getFPHDataForPickAndStage",
      false,
    );
  }
}

function convertToFPHModel(response, process) {
  return {
    metricName: process,
    value: response.values[0].metricValue,
  };
}

async function getFPHData(dispatcher, request) {
  const cycleId =
    request.filters.toString() !== ""
      ? request.filters.toString()
      : "AllCycles";
  const args = {
    processName: "flow/" + request.processName,
    queryParams: "stationCode=" + request.stationCode + "&cycleId=" + cycleId,
  };
  const startTime = Date.now();
  getOverviewData(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(startTime, metricProcessName, "getFPHData", true);
      if (result.data) {
        dispatcher({ type: "RECEIVE_FPH_DATA", data: result.data });
      }
    } else {
      logOperationalMetric(startTime, metricProcessName, "getFPHData", false);
    }
  });
}

export async function getStowWipData(dispatcher, cycleId) {
  const args = {
    processName: "flow/stow-wip",
    queryParams: "stationCode=" + getStationCode() + "&cycleId=" + cycleId,
  };
  const startTime = Date.now();
  getOverviewData(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getStowWipData",
        true,
      );
      if (result.data) {
        dispatcher({ type: "RECEIVE_STOW_WIP_DATA", data: result.data });
      }
    } else {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getStowWipData",
        false,
      );
    }
  });
}

export async function getOcrData(dispatcher, cycleId) {
  const args = {
    processName: "flow/induct-risk",
    queryParams: "stationCode=" + getStationCode() + "&cycleId=" + cycleId,
  };
  const startTime = Date.now();
  getOverviewData(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(startTime, metricProcessName, "getOcrData", true);
      if (result.data) {
        dispatcher({ type: "RECEIVE_OCR_DATA", data: result.data });
      }
    } else {
      logOperationalMetric(startTime, metricProcessName, "getOcrData", false);
    }
  });
}

export async function getStowWipComplianceData(dispatcher, cycleId) {
  const args = {
    processName: "flow/stow-wip/compliance",
    queryParams: "stationCode=" + getStationCode() + "&cycleId=" + cycleId,
  };
  const startTime = Date.now();
  getOverviewData(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getStowWipComplianceData",
        true,
      );
      if (result.data) {
        dispatcher({
          type: "RECEIVE_STOW_WIP_COMPLIANCE_DATA",
          data: result.data,
        });
      }
    } else {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getStowWipComplianceData",
        false,
      );
    }
  });
}

export function fetchStowWipIntervalData(filter, dispatcher) {
  const request = {
    nodeId: getStationCode(),
    cycleId: filter.selectedCycles[0],
  };

  getStowWipIntervalData(dispatcher, request);
}

async function getStowWipIntervalData(dispatcher, request) {
  const args = {
    processName: "flow/stow-wip/interval",
    queryParams:
      "stationCode=" + request.nodeId + "&cycleId=" + request.cycleId,
  };
  const startTime = Date.now();
  getOverviewData(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getStowWipIntervalData",
        true,
      );
      if (result.data) {
        dispatcher({ type: "RECEIVE_WIP_INTERVAL_DATA", data: result.data });
      }
    } else {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getStowWipIntervalData",
        false,
      );
    }
  });
}

async function getComplianceMetrics(dispatcher, processName, request) {
  const cycleId =
    request.filters.toString() !== ""
      ? request.filters.toString()
      : "AllCycles";
  let processURL;
  let queryParams;
  if (processName === "scanCompliance") {
    processURL = "pulse-metric/flow_scan_compliance";
    queryParams = "stationCode=" + request.nodeId + "&cycleId=" + cycleId;
  } else {
    processURL = "flow-pulse-metric/rolledUpVolume";
    queryParams = "stationCode=" + request.nodeId + "&cycleId=" + cycleId;
  }
  const args = {
    processName: processURL,
    queryParams: queryParams,
  };
  const startTime = Date.now();
  getOverviewData(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getComplianceMetrics_" + processName,
        true,
      );
      let output = result.data;
      if (result.data) {
        dispatcher({
          type: "RECEIVE_COMPLIANCE_DATA",
          processName: processName,
          data: output,
        });
      }
    } else {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getComplianceMetrics_" + processName,
        false,
      );
    }
  });
}

function getInductSortTargetDataRequest(request) {
  return {
    resourcePath: "/ivs/getPerformanceMetric",
    httpMethod: "post",
    processName: "induct",
    requestBody: request,
  };
}

async function getInductSortTargetData(dispatcher, request) {
  const args = getInductSortTargetDataRequest(request);
  const startTime = Date.now();
  getAPIGatewayDataFromParent(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getInductSortTargetData",
        true,
      );
      let output = result.data;
      dispatcher({
        type: "RECEIVE_INDUCT_SORT_TARGET_DATA",
        data: {
          INDUCT_FPH: output.groupPerformanceMetrics.TARGET_INDUCT_FPH,
          STOW_FPH: output.groupPerformanceMetrics.TARGET_SORT_FPH,
        },
      });
    } else {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getInductSortTargetData",
        false,
      );
    }
  });
}

function getPVADataRequest(request) {
  return {
    resourcePath: "/ivs/getpvadata",
    httpMethod: "post",
    processName: "induct",
    requestBody: request,
  };
}

async function getPVAData(dispatcher, request) {
  const args = getPVADataRequest(request);
  const startTime = Date.now();
  getAPIGatewayDataFromParent(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(startTime, metricProcessName, "getPVAData", true);
      let output = result.data;
      dispatcher({ type: "RECEIVE_PVA_DATA", data: output });
    } else {
      logOperationalMetric(startTime, metricProcessName, "getPVAData", false);
    }
  });
}

function getNodeLinehaulListRequest(request) {
  return {
    resourcePath: "/ivs/getNodeLineHaulList",
    httpMethod: "post",
    processName: "induct",
    requestBody: request,
  };
}

export async function getNodeLinehaulData(dispatcher) {
  const request = {
    nodeId: getStationCode(),
    groupBy: STRINGS.EMPTY,
  };
  const args = getNodeLinehaulListRequest(request);
  const startTime = Date.now();
  getAPIGatewayDataFromParent(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getNodeLinehaulData",
        true,
      );
      let output = result.data;
      dispatcher({ type: "RECEIVE_NODE_LINEHAUL_DATA", data: output });
    } else {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getNodeLinehaulData",
        false,
      );
    }
  });
}

function getPVAInboundRequest(request) {
  request.processPath = "inbound";
  return {
    resourcePath: "/ivs/getpvadata",
    httpMethod: "post",
    processName: "induct",
    requestBody: request,
  };
}

async function getPVAInbound(dispatcher, request) {
  const args = getPVAInboundRequest(request);
  const startTime = Date.now();
  getAPIGatewayDataFromParent(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(startTime, metricProcessName, "getPVAInbound", true);
      let output = result.data;
      dispatcher({ type: "RECEIVE_INBOUND_DATA", data: output });
    } else {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getPVAInbound",
        false,
      );
    }
  });
}

async function getPerformanceMetric(dispatcher, request, queryParams) {
  const args = {
    processName: "block/tph",
    queryParams: queryParams,
  };
  const startTime = Date.now();
  getOverviewData(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getPerformanceMetric",
        true,
      );
      let output = getPerformanceData(result.data.timedProcessThroughPutData);
      if (result.data) {
        dispatcher({ type: "RECEIVE_TPH", data: output });
      }
    } else {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getPerformanceMetric",
        false,
      );
    }
  });
}

async function getProcessPathAggregateDataMetric(
  dispatcher,
  request,
  queryParams,
) {
  const args = {
    processName: "flow/ppa",
    queryParams: queryParams,
  };
  const startTime = Date.now();
  getOverviewData(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getprocessPathAggregateDataMetric",
        true,
      );
      let output = result.data.timedProcessPathAggregateData;
      if (result.data) {
        dispatcher({ type: "RECEIVE_PPA", data: output });
      }
    } else {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getprocessPathAggregateDataMetric",
        false,
      );
    }
  });
}

/** Get DNC data from Boson **/
export function fetchDNCData(filter, dispatcher) {
  const request = {
    nodeId: getStationCode(),
    filters: filter,
  };
  getDNCData(dispatcher, request);
}

async function getDNCData(dispatcher, request) {
  const cycleId =
    request.filters.toString() !== ""
      ? request.filters.toString()
      : "AllCycles";
  let processURL;
  let queryParams;
  processURL = "pulse-metric/flow_missort";
  queryParams = "nodeId=" + request.nodeId + "&cycleId=" + cycleId;
  const args = {
    processName: processURL,
    queryParams: queryParams,
  };
  const startTime = Date.now();
  getOverviewData(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(startTime, metricProcessName, "getDNCData", true);
      let output = result.data;
      if (result.data) {
        dispatcher({
          type: "RECEIVE_COMPLIANCE_DATA",
          processName: "dnc",
          data: output,
        });
      }
    } else {
      logOperationalMetric(startTime, metricProcessName, "getDNCData", false);
    }
  });
}

export function fetchWipTargetData(processName, dispatcher) {
  const request = {
    stationCode: getStationCode(),
    processName: processName,
  };
  getWipTargetData(dispatcher, request);
}

async function getWipTargetData(dispatcher, request) {
  const args = {
    processName: "flow/" + request.processName,
    queryParams:
      "stationCode=" + request.stationCode + "&" + metricPlanIdentifier,
  };
  const startTime = Date.now();
  getOverviewData(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getWipTargetData",
        true,
      );
      if (result.data) {
        dispatcher({ type: "RECEIVE_WIP_DATA", data: result.data });
      }
    } else {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getWipTargetData",
        false,
      );
    }
  });
}

function getArrivedAPIGatewayRequest(request) {
  return {
    resourcePath: "/ivs/getPackageMetric",
    httpMethod: "post",
    processName: "induct",
    requestBody: request,
  };
}
export function fetchArrivedData(filter, dispatcher) {
  let filterMap = {
    Cycle: [filter.selectedCycles[0]],
  };
  const request = {
    nodeId: getStationCode(),
    filters: filterMap,
    groupBy: "Node",
    metricList: ["CURRENT_CYCLE_RECEIVED"],
  };
  getArrivedMetrics(dispatcher, request);
}
async function getArrivedMetrics(dispatcher, request) {
  const args = getArrivedAPIGatewayRequest(request);
  const startTime = Date.now();
  getAPIGatewayDataFromParent(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getPackageMetrics",
        true,
      );
      const output = result.data.groupedPackageMetrics;
      const stationCode = getStationCode();
      dispatcher({
        type: "RECEIVE_ARRIVED_DATA",
        data: {
          arrived_total_volume: output.CURRENT_CYCLE_RECEIVED[stationCode],
        },
      });
    } else {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getPackageMetrics",
        false,
      );
    }
  });
}

export function getSettingsInsights() {
  const args = {
    processName: "station-plan",
    queryParams: "stationCode=" + getStationCode(),
  };
  const startTime = Date.now();
  return getOverviewData(args).then((result) => {
    logOperationalMetric(
      startTime,
      metricProcessName,
      "getSettingsInsights",
      result.status === HTTP_SUCCESS_STATUS,
    );
    if (result.status === 200 && result.data) {
      return formatGetPlanDetails(result.data);
    } else {
      return {};
    }
  });
}

export function getOpsClockEventsAndBreaks(dispatchDate) {
  const request = getLMOpsCoralServiceRequest("getBreaks", {
    dispatchDate,
    nodeId: getStationCode(),
  });
  const startTime = Date.now();
  return getCoralServiceDataFromParent(request).then((res) => {
    logOperationalMetric(
      startTime,
      metricProcessName,
      "getOpsClockEventsAndBreaks",
      res.status === HTTP_SUCCESS_STATUS,
    );
    if (res.status === 200 && res.data) {
      return res.data;
    } else {
      return {};
    }
  });
}

export function buildShiftPlansRequest(date) {
  const nodeId = getStationCode();
  return {
    resourcePath: `/shift-plans`,
    httpMethod: "GET",
    processName: "shiftPlanManagementService",
    requestParams: {
      nodeId: [nodeId],
      ofdDate: [date],
    },
  };
}

export async function getDynamicShiftPlans() {
  const stationInsights = await getSettingsInsights();
  const date = getDispatchDate(stationInsights);
  const request = buildShiftPlansRequest(date);
  const startTime = Date.now();
  return getAPIGatewayDataFromParent(request).then((result) => {
    logOperationalMetric(
      startTime,
      metricProcessName,
      "getDynamicShiftPlans",
      result.status === HTTP_SUCCESS_STATUS,
    );
    if (result.status === 200) {
      const [latestDynamicPlan, previousDynamicPlan] = getDynamicPlansForDiff(
        result.data,
      );
      return {
        latestDynamicPlan,
        previousDynamicPlan,
      };
    } else {
      return {};
    }
  });
}

export function buildDiffRequest(plan1, plan2, parameterList) {
  return {
    resourcePath: `/shift-plans/diff`,
    httpMethod: "GET",
    processName: "shiftPlanManagementService",
    requestParams: {
      planId1: [plan1.planId],
      planId2: [plan2.planId],
      parameterList,
    },
  };
}

export function getDynamicShiftPlanDiff(plan1, plan2, parameterList) {
  const request = buildDiffRequest(plan1, plan2, parameterList);
  const startTime = Date.now();
  return getAPIGatewayDataFromParent(request).then((result) => {
    logOperationalMetric(
      startTime,
      metricProcessName,
      "getDynamicShiftPlanDiff",
      result.status === HTTP_SUCCESS_STATUS,
    );
    if (result.status === 200) {
      return {
        dynamicShiftPlanDiff: {
          isSame: result.data.headCountDiff.isSame,
          planActedUpon: isPlanActedUpon(plan1),
          data: result.data.headCountDiff.headCountMappings,
          plan1: plan1,
          plan2: plan2,
        },
      };
    } else {
      return {};
    }
  });
}

function buildGetShiftPlanRequest(planId) {
  return {
    resourcePath: `/shift-plans/plan`,
    httpMethod: "GET",
    processName: "shiftPlanManagementService",
    requestParams: {
      planId: [planId],
    },
  };
}

export async function getLatestDynamicShiftPlan(dispatcher) {
  const stationInsights = await getSettingsInsights();
  const date = getDispatchDate(stationInsights);
  const request = buildShiftPlansRequest(date);
  let planId;
  const startTime = Date.now();
  await getAPIGatewayDataFromParent(request).then((result) => {
    logOperationalMetric(
      startTime,
      metricProcessName,
      "getShiftPlanId",
      result.status === HTTP_SUCCESS_STATUS,
    );
    if (result.status === 200) {
      planId = getLatestDynamicPlanId(result.data);
    }
  });

  if (planId) {
    const getShiftPlanRequest = buildGetShiftPlanRequest(planId);
    getAPIGatewayDataFromParent(getShiftPlanRequest).then((result) => {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getShiftPlan",
        result.status === HTTP_SUCCESS_STATUS,
      );
      if (result.status === 200) {
        dispatcher({
          type: "RECEIVE_LATEST_DYNAMIC_SHIFT_PLAN",
          data: result.data,
        });
      }
    });
  }
}

function buildGetMasterPlanRequest(nodeId, resolution, date) {
  return {
    resourcePath: `shift-plans/master-plan`,
    httpMethod: "GET",
    processName: "shiftPlanManagementService",
    requestParams: {
      nodeId: [nodeId],
      resolution: [resolution],
      ofdDate: [date],
    },
  };
}

export async function getMasterPlan(dispatcher) {
  const nodeId = getStationCode();
  const resolution = RESOLUTION.HOURLY;
  const stationInsights = await getSettingsInsights();
  const date = getDispatchDate(stationInsights);
  const request = buildGetMasterPlanRequest(nodeId, resolution, date);

  const startTime = Date.now();
  await getAPIGatewayDataFromParent(request).then((result) => {
    logOperationalMetric(
      startTime,
      metricProcessName,
      "getMasterPlan",
      result.status === HTTP_SUCCESS_STATUS,
    );
    if (result.status === 200) {
      dispatcher({
        type: "RECEIVE_MASTER_PLAN",
        data: result.data,
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/components/overview/network/OverviewNetworkAPI.js